import { DEFAULT_PAGINATION } from "constants/common/common";
import { CommonParamsType } from "constants/types/common";
import { useState } from "react";

export const useTableParams = <T extends CommonParamsType = CommonParamsType>(
  initialExtra?: Partial<Omit<T, keyof CommonParamsType>>,
) => {
  const [params, setParams] = useState<T>({
    ...DEFAULT_PAGINATION,
    ...initialExtra,
  } as T);

  const handlePageChange = (page: number) => {
    setParams((prev) => ({ ...prev, page }));
  };

  const handleLimitChange = (limit: number) => {
    setParams((prev) => ({ ...prev, limit: Number(limit), page: 1 }));
  };

  const handleSearch = (search: string) => {
    setParams((prev) => ({ ...prev, search, page: 1 }));
  };

  const handleFilterChange = <K extends keyof Omit<T, keyof CommonParamsType>>(
    key: K,
    value: T[K] | undefined,
  ) => {
    setParams((prev) => ({ ...prev, [key]: value, page: 1 }));
  };

  return {
    params,
    setParams,
    handlePageChange,
    handleLimitChange,
    handleSearch,
    handleFilterChange,
  };
};
